export * from './colors';

export { default as defaultTheme } from './default';
